import useGetNotifications from './useGetNotifications'

export default useGetNotifications
